<template>
  <div class="btn_group">
    <a
      class="btn_default-a medium go_list mo_hidden"
      @click="$router.push(`/mypacks?tab=${purchaseType}`)"
    >
      목록
    </a>
    <div class="btn_group_s">
      <button
        v-if="buttonStates.reorder"
        type="button"
        class="btn_default-b medium ml8"
        @click="$emit('on-reorder')"
      >
        재주문
      </button>
      <button
        v-if="buttonStates.orderCancel"
        type="button"
        class="btn_default-a medium ml8"
        @click="onCancelPack('single')"
      >
        주문취소
      </button>
      <button
        v-if="buttonStates.cancelSubscription"
        type="button"
        class="btn_default-a medium ml8"
        @click="onCancelPack('recurring')"
      >
        정기구매 취소
      </button>
      <button
        v-if="buttonStates.changePaymentInfo"
        type="button"
        class="btn_default-a medium ml8"
        @click="onChangePaymentInfo"
      >
        결제정보 변경
      </button>
      <button
        v-if="buttonStates.resendConsultationUrl"
        type="button"
        class="btn_default-b medium ml8"
        @click="onResendConsultationUrl"
      >
        상담 URL 재발송
      </button>
      <button
        v-if="buttonStates.resendConsultationInfo"
        type="button"
        class="btn_default-b medium ml8"
        @click="onResendConsultationInfo"
      >
        상담 안내 재발송
      </button>
      <button
        v-if="buttonStates.resendSubscriptionUrl"
        type="button"
        class="btn_default-b medium ml8"
        @click="onResendSubscriptionUrl"
      >
        정기구매 URL 재발송
      </button>
      <button
        v-if="buttonStates.approvedSubscription"
        type="button"
        class="btn_default-b medium ml8"
        @click="onApprovedSubscription"
      >
        정기구매 승인
      </button>
      <button
        v-if="buttonStates.paymentCancel"
        type="button"
        class="btn_default-a medium ml8"
        @click="$emit('on-cancel-order')"
      >
        결제 취소
      </button>
      <button
        v-if="buttonStates.checkout"
        type="button"
        class="btn_default-b medium ml8"
        @click="$emit('on-order')"
      >
        즉시 결제
      </button>
      <button
        v-if="buttonStates.stockCheckAndCheckout"
        type="button"
        class="btn_default-a medium ml8"
        @click="$emit('on-order')"
      >
        재고 확인 및 결제
      </button>
    </div>
    <modal-confirm ref="refConfirm" />
    <modal-alert ref="refAlert" />
  </div>
</template>

<script>
import MypacksItemBtnGroupVue from "@/views/mypacks/main/partial/MypacksItemBtnGroup.vue";

export default {
  extends: MypacksItemBtnGroupVue,
  props: {
    purchaseType: {
      type: String,
      default: 'single'
    }
  },
  data() {
    return {};
  },
};
</script>

<style>
</style>
